import React, { useCallback, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@vio/atlas/context/deviceLayout';
import { SmoothScrollNavigation } from '@vio/atlas/experimental/SmoothScrollNavigation';
import { Flex } from '@vio/atlas/helpers/Flex';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
import { HighlightedTitle } from 'components/Home/HighlightedTitle';
import { getIsRtlLanguage, getLanguageCode, getUserCountryCode } from 'modules/meta/selectors';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Team } from '@daedalus/core/src/analytics/types/Events';
import { TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY } from '@daedalus/core/src/auth/modules/actions';
import { getMyBookingsHost } from '@daedalus/core/src/brand/utils';
import { Title } from '../components/Title';
import { CarouselWidgetsContext } from '../context/CarouselWidgetsContext';
import { Booking } from './components/Booking';
const _exp = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '228px';
const _exp2 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w120xg9u",
  propsAsIs: false,
  vars: {
    "w120xg9u-0": [_exp()],
    "w120xg9u-1": [_exp2()]
  }
});
const _exp3 = /*#__PURE__*/() => Flex.Column;
const SkeletonWrapper = /*#__PURE__*/styled(_exp3())({
  name: "SkeletonWrapper",
  class: "s1q3sau2",
  propsAsIs: true
});
export const YourStays = () => {
  const {
    brand
  } = useBrand();
  const bookingHost = getMyBookingsHost({
    brand,
    appEnv: process.env.NEXT_PUBLIC_ENV
  });
  const {
    isMobile
  } = useDeviceLayout();
  const isRtlLanguage = useSelector(getIsRtlLanguage);
  const languageCode = useSelector(getLanguageCode);
  const userCountry = useSelector(getUserCountryCode);
  const dispatch = useDispatch();
  const {
    bookings,
    bookingsIsFetching
  } = useContext(CarouselWidgetsContext);
  const trackingPayload = {
    component: 'YourStays',
    team: Team.Retention
  };
  useEffect(() => {
    if (bookings?.length) {
      dispatch(trackEvent({
        category: Category.System,
        entity: Entity.Carousel,
        action: Action.Displayed,
        payload: {
          totalNumber: bookings?.length
        },
        ...trackingPayload
      }));
    }
  }, [bookings, dispatch]);
  const handleBookingClick = useCallback((booking, index) => {
    setTimeout(() => {
      dispatch(trackEvent({
        category: Category.User,
        entity: Entity.CarouselCard,
        action: Action.Clicked,
        ...trackingPayload,
        payload: {
          totalNumber: bookings.length,
          index,
          searchItem: {
            hotelId: booking.hotelId,
            checkIn: booking.checkIn,
            checkOut: booking.checkOut,
            rooms: booking.rooms
          }
        }
      }));
      window.location.href = `${bookingHost}/bookings?bookingId=${booking.id}&locale=${languageCode}&showBackButton=true&userCountry=${userCountry}`;
    }, TRACKING_TIMEOUT_BEFORE_NAVIGATING_AWAY);
  }, [dispatch, bookings, bookingHost, languageCode, userCountry]);
  if (bookingsIsFetching) {
    return <SkeletonWrapper gap="s500">
        <SkeletonLoader height={30} width={227} />
        <Flex.Row gap="s500">
          <SkeletonLoader height={88} width={227} />
          <SkeletonLoader marginTop={0} height={88} width={227} />
          <SkeletonLoader marginTop={0} height={88} width={227} />
        </Flex.Row>
      </SkeletonWrapper>;
  }
  if (!bookingsIsFetching && !bookings?.length) {
    return null;
  }
  return <div>
      <Title variant="titleXL">
        <HighlightedTitle source="YourStays" />
      </Title>
      <SmoothScrollNavigation isRtlLanguage={isRtlLanguage} hasSidePaddings={isMobile}>
        {bookings.map((booking, index) => <Wrapper key={`bookings-${booking.id}`} fullWidth={isMobile}>
            <Booking fullWidth={isMobile} hotelId={booking.hotelId} checkIn={booking.checkIn} checkOut={booking.checkOut} rooms={booking.rooms} onClick={() => handleBookingClick(booking, index)} />
          </Wrapper>)}
      </SmoothScrollNavigation>
    </div>;
};

require("./YourStays.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./YourStays.tsx");